export default __webpack_public_path__ + "static/media/TL13.d567aeb5.mp3";